import lozad from "lozad";
export default function lozadInit() {
	console.log("lozadInit");
	const observer = lozad();
	const backgroundObserver = lozad('.lozad-bg', {
		threshold: 0.1,
	});
	observer.observe();
	backgroundObserver.observe();
}
window.lozadInit = lozadInit;
